import React from 'react';
import AsyncPage from './async';
import DefaultConsumerLayout from '../../../../components/layout/DefaultConsumerLayout';

export default [
  <DefaultConsumerLayout
    key="/consumer/apps/yca"
    exact
    path="/consumer/apps/yca"
    component={AsyncPage}
  />,
];
